import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getDevice } from '@panel/commons/helpers';
import { StepperOperations } from '../../../../ducks/stepper';
import { ReactComponent as CopyIcon } from '../../../../../assets/icons/copy_icon.svg';
import { ReactComponent as MailIcon } from '../../../../../assets/icons/mail_icon.svg';
import { ReactComponent as PhoneIcon } from '../../../../../assets/icons/phone_icon.svg';
import { ReactComponent as WhatsAppIcon } from '../../../../../assets/icons/whatsapp_icon.svg';
import {
  Wrapper,
  Title,
  Subtitle,
  ContactName,
  Row,
  IconWrapper,
  CopyButton,
  WhatsAppLink,
  ECommerceButton
} from './styles';
import { getEnabledEcommerceSites, isPeru, isBrazil, isArgentina } from '../utils';

const NoAvailablePlans = ({ contactInfo, isZonaDemandLocation }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const device = getDevice();
  const handleCopy = text => {
    navigator.clipboard.writeText(text);
  };

  return (
    <Wrapper device={device} data-publi='publicador-publishStep-emptyState-container'>
      <Title data-publi='publicador-publishStep-emptyState-title'>
        {t('professionalPubli.publish.emptyState.title')}
      </Title>
      <Subtitle data-publi='publicador-publishStep-emptyState-subtitle' device={device}>
        {t(`professionalPubli.publish.emptyState.subTitle${!contactInfo?.hasContactInfo ? '.noContactInfo' : ''}`)}
      </Subtitle>
      <ContactName device={device} data-publi='publicador-publishStep-emptyState-contact-name'>
        {contactInfo.name}
      </ContactName>
      {contactInfo.email && (
        <Row data-publi='publicador-publishStep-emptyState-row-email' device={device}>
          <IconWrapper
            data-publi='publicador-publishStep-emptyState-row-email-info'
            isPeru={isPeru}
            isBrazil={isBrazil}
          >
            <MailIcon name='email' width={16} height={16} />
            {contactInfo.email}
          </IconWrapper>
          <CopyButton
            type='button'
            data-publi='publicador-publishStep-emptyState-copy-email'
            onClick={() => {
              handleCopy(contactInfo.email);
              dispatch(
                StepperOperations.setSnackAction({
                  action: 'EmailCopied',
                  result: 'SUCCESS',
                  component: t('professionalPubli.publish.emptyState.copied.mail'),
                  section: 'Publicador profesionales - Mail copiado',
                  preventDuplicateActions: true,
                  preventStacking: true
                })
              );
            }}
          >
            {t('professionalPubli.publish.emptyState.copy')} <CopyIcon name='copy' width={16} height={16} />
          </CopyButton>
        </Row>
      )}
      {contactInfo?.phone?.trim() && (
        <>
          <Row data-publi='publicador-publishStep-emptyState-row-phone' device={device}>
            <IconWrapper
              data-publi='publicador-publishStep-emptyState-row-phone-info'
              isPeru={isPeru}
              isBrazil={isBrazil}
            >
              <PhoneIcon name='phone' width={16} height={16} />
              {contactInfo.phone}
            </IconWrapper>
            <CopyButton
              type='button'
              data-publi='publicador-publishStep-emptyState-copy-phone'
              onClick={() => {
                handleCopy(contactInfo.phone);
                dispatch(
                  StepperOperations.setSnackAction({
                    action: 'PhoneCopied',
                    result: 'SUCCESS',
                    component: t('professionalPubli.publish.emptyState.copied.phone'),
                    section: 'Publicador profesionales - Teléfono copiado',
                    preventDuplicateActions: true,
                    preventStacking: true
                  })
                );
              }}
            >
              {t('professionalPubli.publish.emptyState.copy')} <CopyIcon name='copy' width={16} height={16} />
            </CopyButton>
          </Row>
          {contactInfo?.phone?.trim() && contactInfo?.hasContactInfo && (
            <Row data-publi='publicador-publishStep-emptyState-row-phone' device={device}>
              <IconWrapper isPeru={isPeru} isBrazil={isBrazil}>
                <WhatsAppIcon name='whatsApp' width={16} height={16} />
                <WhatsAppLink target='_blank' href={`https://wa.me/${contactInfo.phone}`} device={device}>
                  {t('professionalPubli.publish.emptyState.whatsapp')}
                </WhatsAppLink>
              </IconWrapper>
            </Row>
          )}
          {(isBrazil || isArgentina) && !contactInfo?.hasContactInfo && (
            <Row data-publi='publicador-publishStep-emptyState-row-phone2' device={device}>
              <IconWrapper
                data-publi='publicador-publishStep-emptyState-row-phone2-info'
                isPeru={isPeru}
                isBrazil={isBrazil}
              >
                <WhatsAppIcon name='whatsApp' width={16} height={16} />
                <WhatsAppLink
                  target='_blank'
                  href={t('professionalPubli.publish.emptyState.defaultPhone.whatsappLink')}
                  device={device}
                >
                  {t('professionalPubli.publish.emptyState.whatsapp')}
                </WhatsAppLink>
              </IconWrapper>
            </Row>
          )}
        </>
      )}
      {getEnabledEcommerceSites() && (
        <ECommerceButton
          href={
            t('professionalPubli.publish.emptyState.ecommerceUrl') + (isZonaDemandLocation ? '?ref=zonademand' : '')
          }
          target='_blank'
          rel='noopener noreferrer'
          data-publi='publicador-publishStep-emptyState-ecommerce-button'
        >
          {t('professionalPubli.publish.emptyState.ecommerce')}
        </ECommerceButton>
      )}
    </Wrapper>
  );
};

export default NoAvailablePlans;
